// extracted by mini-css-extract-plugin
export default {"crown":"crown--hiEcd","email":"email--Kx46I","avatar":"avatar--Hvy8y","defaultAvatar":"defaultAvatar--_Zpvw","iconWrapper":"iconWrapper--UdHKS"};